import script from "./SceneUp.vue?vue&type=script&setup=true&lang=js"
export * from "./SceneUp.vue?vue&type=script&setup=true&lang=js"

import "./SceneUp.vue?vue&type=style&index=0&id=5e00bd38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e00bd38"]])

export default __exports__